__turbopack_context__.v({
  "icon": "zip-code-location-module-scss-module__F26Cnq__icon",
  "mini": "zip-code-location-module-scss-module__F26Cnq__mini",
});
